import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useFixedBgTextLogic } from './FixedBgTextLogic';
import BasicFixedBgTextSkin from './skins/BasicFixedBgTextSkin';

/**
 * FixedBgText 스킨 가능 컴포넌트 정의
 */
export const FixedBgTextSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.FIXED_BG_TEXT,
  name: '고정 배경 텍스트',
  category: 'content',
  icon: '🖼️',
  supportsExternalSkins: true,
  options: [
    {
      key: 'bgImageUrl',
      type: 'text',
      label: '배경 이미지 URL',
      placeholder: 'https://example.com/background.jpg',
      description: '배경으로 사용할 이미지의 URL을 입력하세요'
    },
    {
      key: 'overlayColor',
      type: 'color',
      label: '오버레이 색상',
      default: 'rgba(0, 0, 0, 1)',
      description: '배경 이미지 위의 오버레이 색상'
    },
    {
      key: 'overlayOpacity',
      type: 'slider',
      label: '오버레이 투명도',
      min: 0,
      max: 1,
      default: 0.5,
      description: '오버레이의 투명도 (0: 투명, 1: 불투명)'
    },
    {
      key: 'textColor',
      type: 'color',
      label: '텍스트 색상',
      default: '#ffffff',
      description: '텍스트의 색상'
    },
    {
      key: 'contentAlignment',
      type: 'select',
      label: '콘텐츠 정렬',
      options: [
        { value: 'top', label: '상단' },
        { value: 'center', label: '중앙' },
        { value: 'bottom', label: '하단' }
      ],
      default: 'center',
      description: '콘텐츠의 수직 정렬 위치'
    },
    {
      key: 'height',
      type: 'number',
      label: '높이 (px)',
      default: 500,
      min: 200,
      max: 1000,
      description: '컴포넌트의 최소 높이'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicFixedBgTextSkin as any
  },
  useLogic: useFixedBgTextLogic as any,
  defaultProps: {
    content: {
      html: '<h1>Hero Title</h1><p>This is a hero section with a background image.</p>',
      deviceProperty: {
        pc: '<h1>Hero Title</h1><p>This is a hero section with a background image.</p>',
        mobile: '<h2>Mobile Hero</h2><p>Optimized for mobile devices.</p>'
      }
    },
    componentProps: {
      bgImageUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1600',
      overlayColor: 'rgba(0, 0, 0, 1)',
      overlayOpacity: 0.5,
      textColor: '#ffffff',
      contentAlignment: 'center',
      height: 500,
      skin: 'basic'
    },
    style: {
      width: '100%',
      position: 'relative'
    }
  }
};

export default FixedBgTextSkinnable;